import { Instagram, Mail, MessageCircle } from "lucide-react";

const LOGO = "https://customer-assets.emergentagent.com/job_865b4dbe-c58c-4335-9acb-23d734fc8f3b/artifacts/oe7o0i2i_thequickbrownie_logo-transp.png";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer id="contato" data-testid="site-footer" className="border-t border-black">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10 py-16 md:py-24">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <img src={LOGO} alt="The Quick Brownie" className="h-12 w-auto" />
              <span className="font-display text-xl tracking-tight">The Quick Brownie</span>
            </div>
            <p className="mt-6 font-display text-3xl md:text-5xl leading-[0.95] tracking-[-0.02em]">
              Doçura que te move.
            </p>
          </div>

          <div className="md:col-span-4">
            <p className="text-xs uppercase tracking-[0.2em]">Contato</p>
            <ul className="mt-6 space-y-4 text-base">
              <li>
                <a
                  href="https://wa.me/5521997692454"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-whatsapp"
                  className="inline-flex items-center gap-3 hover:underline underline-offset-4"
                >
                  <MessageCircle size={18} /> +55 21 99769-2454
                </a>
              </li>
              <li>
                <a
                  href="https://instagram.com/thequickbrownie"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-instagram"
                  className="inline-flex items-center gap-3 hover:underline underline-offset-4"
                >
                  <Instagram size={18} /> @thequickbrownie
                </a>
              </li>
              <li>
                <a
                  href="mailto:thequickbrownie@gmail.com"
                  data-testid="footer-email"
                  className="inline-flex items-center gap-3 hover:underline underline-offset-4"
                >
                  <Mail size={18} /> thequickbrownie@gmail.com
                </a>
              </li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <p className="text-xs uppercase tracking-[0.2em]">Navegue</p>
            <ul className="mt-6 space-y-3 text-base">
              <li><a href="#sabores" className="hover:underline underline-offset-4">Sabores</a></li>
              <li><a href="#manifesto" className="hover:underline underline-offset-4">Manifesto</a></li>
              <li><a href="#pedido" className="hover:underline underline-offset-4">Pedido</a></li>
              <li><a href="#faq" className="hover:underline underline-offset-4">FAQ</a></li>
            </ul>
          </div>
        </div>

        <div className="hairline mt-16" />

        <div className="mt-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-xs uppercase tracking-[0.2em]">
          <span>© {year} The Quick Brownie · Todos os direitos reservados</span>
          <span>Sem açúcar · Sem glúten · Sem lactose · Sem desculpas</span>
        </div>
      </div>
    </footer>
  );
}
